<template>
  <div v-if="isEditing">
    <el-form-item prop="title" label="题目">
      <wjQuillEditor :content="tempQuesData.title" :config="config" @onChange="handleEditorChange"></wjQuillEditor>
    </el-form-item>
    <el-form-item label="备注">
      <el-input class="editor-input" v-model="tempQuesData.description"></el-input>
      <span class="answerActive" v-if="!rightKey && tempQuesData.evaluateFlag">请选择正确答案</span>
    </el-form-item>
    <span
      v-if="tempQuesData.referFlag"
      class="addOtherButton quoteOption bottom10"
    >此题选项来源于第 {{tempQuesData.referIndex}} 题中的选中项</span>
    <div>
      <el-form
        v-if="!tempQuesData.referFlag"
        :rules="optRule"
        v-for="(option, index) in tempQuesData.options"
        label-width="80px"
        :model="option"
        :key="index"
      >
        <el-form-item prop="text" :label="'单选' + (letterMap[index] || '')">
          <wjQuillEditor
            v-if="option.id !== '98'"
            :content="option.text"
            :option="option"
            :config="config"
            @onChange="handleEditorChange"
          ></wjQuillEditor>
          <el-input
            v-else
            class="editor-input"
            v-model="option.text"
            :id="'opt_' + option.id"
            :disabled="option.id == '98'"
          ></el-input>
          <i class="el-icon-close" @click="deleteOption(tempQuesData, index)"></i>
          <el-checkbox
            v-if="tempQuesData.random"
            class="requiredCheck"
            v-model="option.noRandom"
          >不随机</el-checkbox>
          <el-radio
            v-if="tempQuesData.evaluateFlag"
            class="requiredCheck"
            :label="option.id"
            v-model="rightKey"
            @change="handleRightKeyChange"
          >正确</el-radio>
        </el-form-item>
      </el-form>
      <div class="addOptionBtn" @click="addRadioOpt" v-if="!tempQuesData.referFlag">新建选项</div>
      <el-button
        type="text"
        class="addOtherButton"
        v-if="!tempQuesData.referFlag"
        :disabled="tempQuesData.blankSetting.length > 0"
        @click="handleAddOtherRadio"
      >添加「其他」项</el-button>
      <el-button
        type="text"
        class="addOtherBtn"
        v-if="!tempQuesData.referFlag"
        @click="handleBatchChange"
      >批量修改</el-button>
      <el-collapse
        v-model="advancedSetting"
        @change="handleSettingChange"
        class="batchChange backgroundGray"
      >
        <el-collapse-item name="1">
          <template slot="title">
            <div class="advanced-setting-title backgroundGray">
              <span class="more-setting-btn">
                {{advancedSettingTitle}}
                <i :class="advanceSettingIcon"></i>
              </span>
            </div>
          </template>
          <div class="backgroundGray">
            <div class="edit-settings">
              <el-form-item label="每行显示">
                <el-select
                  size="mini"
                  :disabled="tempQuesData.showStat"
                  class="maxSelectInput"
                  v-model="tempQuesData.maxRow"
                >
                  <el-option v-for="item in options" :label="item" :value="item" :key="item"></el-option>
                </el-select>
                <el-checkbox v-model="tempQuesData.random">选项随机</el-checkbox>
                <el-checkbox
                  v-model="tempQuesData.showStat"
                  @change="handleShowStat"
                  :disabled="tempQuesData.evaluateFlag"
                >显示投票结果</el-checkbox>
                <el-checkbox
                  v-model="tempQuesData.referFlag"
                  :disabled="tempQuesData.evaluateFlag"
                  @change="handleIsQuoteChange"
                >选项引用</el-checkbox>
                <el-select
                  size="mini"
                  v-show="tempQuesData.referFlag"
                  v-model="tempQuesData.refer"
                  @change="handleReferChange"
                  :class="{errorTooltip:(!tempQuesData.refer && tempQuesData.referFlag)}"
                >
                  <el-option
                    v-for="(checkbox, idx) in checkboxs"
                    :label="(checkbox.realIndex + 1) + '.' + checkbox.title"
                    :value="checkbox.id"
                    :key="idx"
                  ></el-option>
                </el-select>
                <span
                  class="answerActive"
                  v-if="!tempQuesData.refer && tempQuesData.referFlag"
                >请选择引用的题目</span>
                <div>
                  <el-checkbox
                    v-model="tempQuesData.evaluateFlag"
                    :disabled="tempQuesData.referFlag || tempQuesData.showStat"
                  >设置为评测题目</el-checkbox>
                  <div class="top10" v-if="tempQuesData.evaluateFlag">
                    <label>题目分值</label>
                    <el-input-number
                      v-model="tempQuesData.assess.score"
                      controls-position="right"
                      :min="1"
                      :max="100"
                      size="mini"
                    ></el-input-number>
                  </div>
                </div>
              </el-form-item>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
  <div v-else>
    <div class="ques-title">
      {{ ques.index + 1 }}.
      <p style="display: inline-block;" v-html="ques.title"></p>
      <i v-if="ques.required" class="required-icon">*</i>
      <span
        class="gotoDisp"
        v-if="ques.goto && +ques.goto !== -1"
      >答完本题后跳转至{{ calcToPage(ques.goto) }}</span>
    </div>
    <p class="ques-desc">{{ ques.description }}</p>
    <span v-if="ques.referFlag">此题选项来源于第 {{ques.referIndex}} 题中的选中项</span>
    <el-radio-group v-else v-model="ques.checkedLabel">
      <el-radio
        :class="'row-' + ques.maxRow"
        :key="idx"
        :label="option.text"
        v-for="(option, idx) in ques.options"
      >
        <p class="ques-option-text" v-html="option.text">{{ option.text }}</p>
        <span class="gotoDisp" v-if="option.goto">跳转至{{ calcToQues(option.goto) }}</span>
        <span
          class="gotoDisp"
          v-if="option.mulKey"
        >选择第{{+option.mulKey.split('-')[0] + 1}}题{{option.mulKey.split('-')[1].split(',').map(val => letterMap[val]).join()}}选项后，显示第{{option.mulToQues.map(val => val + 1).join()}}题</span>
        <span
          class="gotoDisp"
          v-if="option.visible.length > 0"
        >选择后显示第{{option.visible.map(val => val + 1).join()}}题</span>
      </el-radio>
    </el-radio-group>
  </div>
</template>
<script>
import wjQuillEditor from "./wj-quill-editor.vue";
import { letterMap } from "../utils/constant";
import { quesMixin } from '../utils/mixins'
export default {
  name: "radio",
  mixins: [quesMixin],
  data() {
    return {
      options: [1,2,3,4,5,6,7,8,9,10],
      letterMap: letterMap,
      rightKey: this.tempQuesData
        ? this.tempQuesData.assess.options[0] || ""
        : ""
    };
  },
  props: [
    "tempQuesData",
    "isEditing",
    "ques",
    "item",
    "checkboxs",
    "survey",
    "config",
    "activePage"
  ],
  components: {
    wjQuillEditor
  },
  methods: {
    handleAddOtherRadio() {
      this.$emit("addOtherRadio", this.tempQuesData);
    },
    handleBatchChange() {
      this.$emit("batchChange", this.tempQuesData.options);
    },
    addRadioOpt() {
      this.$emit("addRadioOpt", this.tempQuesData.options);
    },
    calcToQues(toQues) {
      if (+toQues === -1) {
        return "无效问卷";
      } else if (+toQues === -2) {
        return "结束页";
      }
      return "第" + (+toQues + 1) + "题";
    },
    calcToPage(goto) {
      let _sum = 0;
      if (+goto === -2) {
        return "结束页";
      }
      for (let i = 0; i < this.survey.pages.length; i++) {
        let _page = this.survey.pages[i];
        for (let j = 0; j < _page.questions.length; j++) {
          if (_page.questions[j].type !== "description") {
            if (_sum === +goto) return "第" + (i + 1) + "页";
            _sum++;
          }
        }
      }
    },
    deleteOption(ques, idx) {
      if (ques.options[idx].id === "98") ques.blankSetting = [];
      ques.options.splice(idx, 1);
    },
    handleReferChange(refer) {
      let pages = this.survey.pages;
      for (let i = 0; i < pages.length; i++) {
        pages[i].questions.forEach(item => {
          let { id, index, title, type, options } = item;
          if (type === "checkbox" && id === refer) {
            this.tempQuesData.options = options;
            this.tempQuesData.referIndex = index + 1;
          }
        });
      }
    },
    handleIsQuoteChange() {},
    handleRightKeyChange() {
      this.tempQuesData.assess.options = new Array(this.rightKey);
    },
    handleShowStat(val) {
      if (val) this.tempQuesData.maxRow = 1;
    },
    handleEditorChange(data, option) {
      if (option) {
        option.text = data;
      } else {
        this.tempQuesData.title = data;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.ques-option-text {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/radio.vue